<template>
  <highcharts v-if="loaded" :options="chartOptions"></highcharts>
</template>

<script>
  import GraficosService from '@/services/GraficosService';
  import More from 'highcharts/highcharts-more';
  import Highcharts from 'highcharts';
  More(Highcharts);

  export default {
    name: 'DiferencaAisGeoNegativeBar',

    data() {
      return {
        fireData: []
      };
    },
    computed: {
      loaded: function () {
        return this.fireData != null && this.fireData.length != 0;
      },

      chartOptions: function () {
        return {
          chart: {
            type: 'bar',
            style: {
              //color: '#FF00FF',
              //fontWeight: 'bold',
              fontFamily: 'muli'
            },
            height: 250
          },
          credits: {
            enabled: false
          },
          title: {
            text: '',
            align: 'left'
          },
          accessibility: {
            point: {
              valueDescriptionFormat: '{value}'
            }
          },
          xAxis: [
            {
              categories: this.categories,
              reversed: false,
              labels: {
                step: 1
              }
            }
          ],
          yAxis: {
            title: {
              text: null
            },
            labels: {
              formatter: function () {
                return Highcharts.numberFormat(this.value, 0, ',') + '%';
              }
            },
            accessibility: {
              //description: 'Percentage population',
              //rangeDescription: 'Range: 0 to 5%'
            }
          },

          plotOptions: {
            series: {
              stacking: 'normal'
            },
            bar: {
              dataLabels: {
                enabled: false,
                color: 'black',
                style: {
                  textOutline: false
                },
                formatter: function () {
                  if (this.point.y != 0) {
                    //return '<span style="border: 5px solid black; color:white;">'+Highcharts.numberFormat(Math.abs(this.point.y), 1) + '%</span>';
                    return Highcharts.numberFormat(Math.abs(this.point.y), 1) + '%';
                  }
                }
              }
            }
          },

          tooltip: {
            formatter: function () {
              return this.point.category + ' Aderência: ' + Highcharts.numberFormat(Math.abs(this.point.y), 1) + '%';
            }
          },

          legend: {
            enabled: false
          },

          series: [
            {
              name: 'BDGD',
              data: this.fireDataSeries['geo'],
              color: '#F7C6BB'
            },
            {
              name: 'AIS',
              data: this.fireDataSeries['ais'],
              color: '#FCD3A2'
            }
          ]
        };
      },

      categories: function () {
        let array = [];
        Object.entries(this.fireData).forEach(function (element) {
          if (element[1].Diferença != 0) {
            array.push(element[1]['Ativo']);
          }
        });
        return array.reverse();
      },

      fireDataSeries: function () {
        let data = [];
        let auxAis = [];
        let auxGeo = [];

        Object.entries(this.fireData).forEach(function (element) {
          if (element[1].Diferença != 0) {
            if (element[1].Diferença < 0) {
              auxAis.push(element[1].Diferença * 100);
              auxGeo.push(0);
            } else {
              auxGeo.push(element[1].Diferença * 100);
              auxAis.push(0);
            }
          }
        });

        data['geo'] = auxGeo.reverse();
        data['ais'] = auxAis.reverse();

        return data;
      }
    },
    mounted() {
      this.getDadosDashboard();
    },
    methods: {
      getDadosDashboard() {
        return GraficosService.getDadosByNome('Firebase - Diferenças: Geo x AIS')
          .then(({ data }) => {
            this.fireData = Object.values(data.data);
          })
          .catch((err) => {
            this.$toast.error('Erro ao buscar os dados do Dashboard', '', {
              position: 'topRight'
            });
            console.error(err);
          });
      }
    }
  };
</script>
